// extracted by mini-css-extract-plugin
export default {"body":"ContentArea_body__5oLhd","list":"ContentArea_list__opuf3"};